module.exports = __webpack_public_path__ + "img/close.b90e1e23.svg";